<script>
  import Center from './center.svelte';
</script>

<div>
  <Center>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
  </Center>
</div>

<style>
  @keyframes loop_fadeIn {
    from {
      opacity: 0;
      transform: rotate(-20deg) scale(0.7);
    }

    to {
      opacity: 1;
      transform: rotate(0deg) scale(1);
    }
  }

  div {
    margin: 0px auto;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: var(--loop-primary);
    color: var(--loop-primaryText);
    animation: loop_fadeIn 0.5s 0.2s forwards;
    opacity: 0;
  }

  svg {
    height: 22px;
    width: 22px;
  }
</style>
